/**
 * Honeypot Spam Prevention
 *
 * Simple honeypot field implementation to prevent bot form submissions.
 * Bots auto-fill all fields including hidden ones; legitimate users only fill visible fields.
 *
 * Features:
 * - Listens for all form submissions on the page
 * - Checks if honeypot field (hidden) has been filled
 * - Blocks submission if honeypot contains a value (bot detected)
 * - Uses event capture phase for early interception
 *
 * HTML Structure:
 *   <form>
 *     <input type="text" name="website" data-hs-form="form-handler" style="display:none">
 *   </form>
 *
 * Best Practices:
 *   - Hide with CSS (display:none), not type="hidden"
 *   - Use realistic field names ("website", "company")
 *   - No visible label or placeholder
 */

import { querySelector } from '@utils';

export function init(config) {
  // Centralized cleanup tracking
  const cleanup = {
    honeypotHandler: null,
  };

  // Honeypot spam prevention
  const honeypotHandler = (e: Event) => {
    const form = e.target as HTMLElement;
    if (form.tagName !== 'FORM') return;

    const honeypot = querySelector(config, 'form-handler', form) as HTMLInputElement;
    if (honeypot && honeypot.value) {
      // Honeypot filled - likely a bot
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  };

  cleanup.honeypotHandler = honeypotHandler;
  document.addEventListener('submit', honeypotHandler, true);

  return {
    result: 'honeypot initialized',
    destroy: () => {
      // Remove honeypot handler
      if (cleanup.honeypotHandler) {
        document.removeEventListener('submit', cleanup.honeypotHandler, true);
        cleanup.honeypotHandler = null;
      }
    },
  };
}
